import { type RouteObject } from 'react-router';
import { Root } from './root';
import { LandingPage } from './pages/LandingPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
import { FootprintPage } from './pages/FootprintPage';
import { BlogPage, blogPageLoader } from './pages/BlogPage';
import { BlogPostPage, blogPostPageLoader } from './pages/BlogPostPage';
import { LocaleRedirect } from './components/LocaleRedirect';
import { LocaleLayout } from './components/LocaleLayout';

const localizedRoutes: RouteObject[] = [
  {
    index: true,
    element: <LandingPage />,
  },
  {
    path: 'privacy',
    element: <PrivacyPage />,
  },
  {
    path: 'terms',
    element: <TermsPage />,
  },
  {
    path: 'footprint',
    element: <FootprintPage />,
  },
  {
    path: 'blog',
    element: <BlogPage />,
    loader: blogPageLoader,
  },
  {
    path: 'blog/:slug',
    element: <BlogPostPage />,
    loader: blogPostPageLoader,
  },
];

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <Root />,
    children: [
      {
        index: true,
        element: <LocaleRedirect />,
      },
      {
        path: ':lang',
        element: <LocaleLayout />,
        children: localizedRoutes,
      },
    ],
  },
];
